import React from 'react';
import './Fields.css';
import { PageHead, SectionWrap } from '../../Components';
import { CiCircleChevLeft } from "react-icons/ci";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



function Fields() {
    const { t, i18n } = useTranslation();
    

  return (
    <>
    <PageHead title={t('fieldsTitle')}
              summary= {t('fieldsSummary')}  
              disc={t('fieldsDisc')}
              btn={t('ourTeam')}
              hrefBtn='/team'
              />
    <div className='fieldHolder containerNew' data-aos='fade-up'>
        <SectionWrap>
        <div className='fielsContainer'>
            <div className='fieldsItem' data-aos='fade-up'>
            <Link to={'/firms'} target='_top'>
            <span>01</span>
            <h4>{t('fieldsShort1')}</h4>
            <p>{t('fieldsShortDisc1')}</p>
            <Link to={'/firms'} target='_top'>{t('readMore')}</Link>
            </Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <Link to={'/property'} target='_top'>
                <span>02</span>
                <h4>{t('fieldsShort2')}</h4>
                <p>{t('fieldsShortDisc2')}</p>
                <Link to={'/property'} target='_top'>{t('readMore')}</Link></Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <Link to={'/conflict'} target='_top'>
                <span>03</span>
                <h4>{t('fieldsShort3')}</h4>
                <p>{t('fieldsShortDisc3')}</p>
                <Link to={'/conflict'} target='_top'>{t('readMore')}</Link>
                </Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <Link to={'/copywrites'} target='_top'>
                <span>04</span>
                <h4>{t('fieldsShort4')}</h4>
                <p>{t('fieldsShortDisc4')}</p>
                <Link to={'/copywrites'} target='_top'>{t('readMore')}</Link>
                </Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <Link to={'/employee'} target='_top'>
                <span>05</span>
                <h4>{t('fieldsShort5')}</h4>
                <p>{t('fieldsShortDisc5')}</p>
                <Link to={'/employee'} target='_top'>{t('readMore')}</Link>
                </Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <Link to={'/taxes'} target='_top'>
                <span>06</span>
                <h4>{t('fieldsShort6')}</h4>
                <p>{t('fieldsShortDisc6')}</p>
                <Link to={'/taxes'} target='_top'>{t('readMore')}</Link>
                </Link>
            </div>
        </div>
    </SectionWrap>
    </div>
    </>
  )
}

export default Fields